export const OPEN = 'open';
export const TOGGLE = 'toggle';